const MAP = {
  draft: { cls: "badge-draft", label: "Draft" },
  submitted: { cls: "badge-submitted", label: "Submitted" },
  under_review: { cls: "badge-review", label: "Under Review" },
  more_info_requested: { cls: "badge-info", label: "Info Requested" },
  validation_requested: { cls: "badge-validate", label: "Validation Requested" },
  validation_in_progress: { cls: "badge-validate", label: "Validation In Progress" },
  validated: { cls: "badge-approved", label: "Validated" },
  validation_uncertain: { cls: "badge-validate", label: "Validation Uncertain" },
  validation_failed: { cls: "badge-denied", label: "Validation Failed" },
  ready_for_approval: { cls: "badge-review", label: "Ready for Approval" },
  approved: { cls: "badge-approved", label: "Approved" },
  denied: { cls: "badge-denied", label: "Not Approved" },
  ready_to_publish: { cls: "badge-approved", label: "Ready to Publish" },
  published: { cls: "badge-published", label: "Published" },
  archived: { cls: "badge-archived", label: "Archived" },
};

export function StatusBadge({ status, memberView = false, className = "" }) {
  const m = MAP[status] || { cls: "badge-draft", label: status };
  const label = memberView
    ? (["validation_requested", "validation_in_progress", "validated",
        "validation_uncertain", "validation_failed", "ready_for_approval", "under_review"].includes(status)
        ? "Under Review" : m.label)
    : m.label;
  return (
    <span className={`badge ${m.cls} ${className}`} data-testid={`status-badge-${status}`}>
      <span className="w-1.5 h-1.5 rounded-full bg-current opacity-70" />
      {label}
    </span>
  );
}
